import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormControl } from '@angular/forms';
import { countBy } from 'lodash';
import { BehaviorSubject, combineLatest, Observable, of } from 'rxjs';
import { map, startWith, switchMap } from 'rxjs/operators';
import { removeFirst } from 'src/util/angular/ng-forms-helpers';
import { SelectItem } from 'src/util/ui/forms';
import { getOrElse } from 'src/util/values';

interface SelectItemCount extends SelectItem {
  count: number;
}

@Component({
  selector: 'fl-multi-quantity-select',
  templateUrl: './multi-quantity-select.component.html',
  styleUrls: ['./multi-quantity-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultiQuantitySelectComponent implements OnInit, OnChanges {
  @Input()
  public options: SelectItem[] = [];
  @Input()
  public formArray: UntypedFormArray;

  public labelValue: { [id: string]: any };
  public options$: Observable<SelectItemCount[]>;
  public selectionSummary$: Observable<string>;
  public componentChanges$ = new BehaviorSubject(null);

  constructor() {}

  public ngOnInit() {
    this.options$ = this.formArray.valueChanges.pipe(
      startWith(this.formArray.value),
      // Options should update if there are any changes
      // eslint-disable-next-line import/no-deprecated
      //combineLatest(this.componentChanges$, (formValue) => formValue),
      switchMap((formValue) => combineLatest([of(formValue), this.componentChanges$])),
      map(([v]) => countBy(v)),
      map((valueCounts) =>
        this.options.map((option) => {
          return {
            ...option,
            count: getOrElse(valueCounts[option.value], 0),
          };
        }),
      ),
    );

    this.selectionSummary$ = this.options$.pipe(
      map((options) =>
        options
          .sort((a, b) => a.count - b.count)
          .filter((o) => o.count > 0)
          .reduce(
            (prev, curr, i) => `${i === 0 ? '' : prev + ', '}${curr.label} (${curr.count})`,
            '',
          ),
      ),
    );
  }

  public ngOnChanges() {
    this.componentChanges$.next(null);
  }

  public increment(event: Event, value: any) {
    // Stop event propogation to prevent md-select dropdown from closing
    event.stopPropagation();
    this.formArray.push(new UntypedFormControl(value));
  }

  public decrement(event: Event, value: any) {
    // Stop event propogation to prevent md-select dropdown from closing
    event.stopPropagation();
    removeFirst(this.formArray, (c) => c.value === value);
  }
}
